import React, { FunctionComponent } from 'react';

import { TreeContainer } from '../../containers/TreeContainer';
import { FilterOptionsProps } from '../../types';
import { CheckboxGroupWrapper } from './CheckboxGroupWrapper';
import { RadioButtonGroupWrapper } from './RadioButtonGroupWrapper';
import { RangeInputWrapper } from './RangeInputWrapper/RangeInputWrapper';

export const FilterOptions: FunctionComponent<FilterOptionsProps> = (props: FilterOptionsProps) => {
  switch (props.filter.type) {
    case 'checkbox':
      return <CheckboxGroupWrapper {...props} />;
    case 'radio':
      return <RadioButtonGroupWrapper {...props} />;
    case 'range':
      return <RangeInputWrapper {...props} />;
    case 'tree':
      return <TreeContainer {...props} />;
    default:
      return null;
  }
};
